import { Component, OnInit } from '@angular/core';
import { MediaService } from '../../core/services/media.service';
import { Router } from '@angular/router';
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-users',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
})
export class MediaComponent implements OnInit {
  breadcrumbs: any[] = [];

  data: any[] = [];

  constructor(
    private mediaService: MediaService,
    private router: Router,
    private datePipe: DatePipe,
  ) {}

  ngOnInit(): void {
    this.initCrumbs();
    this.loadAlbums();
  }

  loadAlbums(): void {
    this.mediaService.getAlbums().then((response) => {
      this.data = response.docs;
    });
  }

  albumNav(id: any) {
    this.router.navigate(['/admin/single-album/', { id }]);
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }

  initCrumbs(): void {
    this.breadcrumbs = [
      {
        title: 'Media Gallery',
      },
    ];
  }

  formatDate(date: string): any {
    const originalDate = new Date(date);
    return this.datePipe.transform(originalDate, 'MMM d, y');
  }
}
